import React from 'react'
import styled from 'styled-components'
import { Icon, Header, Segment } from 'semantic-ui-react'
import { Link } from 'react-router-dom'

const Flex = styled.div`
    margin: 0 auto;
    margin-top: 20px;
    display: flex;
    justify-content: center;
    flex-wrap:wrap;
`

const StyledLink = styled(Link) `
    color: black;
    font-weight: bold;
    text-align: center;
    &:hover{
        color: black;
    }
`

const IconWrapper = styled.div`
    padding: 30px;
    background: #e1edd7;
    border-radius: 4px;
    box-shadow: 3px 3px 3px rgba(0,0,0,0.3);
    transition: transform 0.2s ease;
    &:hover{
        transform: scale(1.05);
    }
`

const ItemWrapper = styled.div`
    margin: 20px 60px;
`

const AdminHome = props => {
    return (
        <Segment size="large">

            <Header as="h2" textAlign="center">Kiinteistöjen valvontajärjestelmän ylläpito</Header>

            <p>
                Järjestelmän kautta voit tarkkailla saatavilla olevia mittaustuloksia valvotuista
                kiinteistöistä. Valvontaan pääset "Kohteet" valikon kautta.
            </p>

            <p>
                Voit myös luoda/poistaa asiakkaita ja yhdistää asiakkaita järjestelmästä löytyviin
                kohteisiin. Kun kohde on linkitetty asiakkaaseen, se on nähtävissä asiakkaan omassa
                valvonnassa, johon pääsee "Asiakkaat" osiosta löytyvän jaettavan linkin kautta.
            </p>

            <Flex>

                <ItemWrapper>
                    <StyledLink to="/admin/asiakkaat">
                        <IconWrapper>
                            <Icon name='user outline' size="huge" />
                            <div>Asiakkaat</div>
                        </IconWrapper>
                    </StyledLink>
                </ItemWrapper>


                <ItemWrapper>
                    <StyledLink to="/admin/kohteet">
                        <IconWrapper>
                            <Icon name='building outline' size="huge" />
                            <div>Kohteet</div>
                        </IconWrapper>
                    </StyledLink>
                </ItemWrapper>


            </Flex>

        </Segment>
    )
}

export default AdminHome


// WEBPACK FOOTER //
// ./src/Admin/AdminHome.js